export const SET_FOLDER_DATA = 'SET_FOLDER_DATA';

export const GET_FOLDER_DIALOGS = 'GET_FOLDER_DIALOGS';
export const GET_FOLDER_DIALOGS_SUCCESS = 'GET_FOLDER_DIALOGS_SUCCESS';
export const GET_FOLDER_DIALOGS_FAILED = 'GET_FOLDER_DIALOGS_FAILED';

export const GET_CHAT_FOLDERS = 'GET_CHAT_FOLDERS';
export const GET_CHAT_FOLDERS_FAILED = 'GET_CHAT_FOLDERS_FAILED';
export const GET_CHAT_FOLDERS_SUCCESS = 'GET_CHAT_FOLDERS_SUCCESS';

export const SET_FOLDERS = 'SET_FOLDERS';

export const REORDER_FOLDERS = 'REORDER_FOLDERS';
export const REORDER_FOLDERS_FAILED = 'REORDER_FOLDERS_FAILED';
export const REORDER_FOLDERS_SUCCESS = 'REORDER_FOLDERS_SUCCESS';

export const CREATE_CHAT_FOLDER = 'CREATE_CHAT_FOLDER';
export const CREATE_CHAT_FOLDER_FAILED = 'CREATE_CHAT_FOLDER_FAILED';
export const CREATE_CHAT_FOLDER_SUCCESS = 'CREATE_CHAT_FOLDER_SUCCESS';

export const EDIT_CHAT_FOLDER = 'EDIT_CHAT_FOLDER';
export const EDIT_CHAT_FOLDER_FAILED = 'EDIT_CHAT_FOLDER_FAILED';
export const EDIT_CHAT_FOLDER_SUCCESS = 'EDIT_CHAT_FOLDER_SUCCESS';

export const DELETE_CHAT_FOLDER = 'DELETE_CHAT_FOLDER';
export const DELETE_CHAT_FOLDER_FAILED = 'DELETE_CHAT_FOLDER_FAILED';
export const DELETE_CHAT_FOLDER_SUCCESS = 'DELETE_CHAT_FOLDER_SUCCESS';

export const SELECT_CHAT_FOLDER = 'SELECT_CHAT_FOLDER';
